'use client';

import { ComponentType, ReactNode } from 'react';
import { redirect } from 'next/navigation';

import { ROUTES } from 'constant/routes';

import { useAppSelector } from 'store/hooks';

import { Loader } from 'ui/Loader';

interface AuthProps {
  children: ReactNode;
}

const withPrivateRouting = (WrappedComponent: ComponentType<AuthProps>) => {
  const AuthComponent = ({ children, ...props }: AuthProps) => {
    const { userInfo } = useAppSelector((state) => state.persistAuth);
    const { user, isLoading } = useAppSelector((state) => state.user);

    const isUserFetching = (isLoading || userInfo) && !user;

    if (isUserFetching) {
      return <Loader fixed />;
    }

    return user ? (
      <>
        <WrappedComponent {...props}>{children}</WrappedComponent>
        {isLoading && <Loader fixed bg='blackOpacity.10' />}
      </>
    ) : (
      redirect(ROUTES.login)
    );
  };

  return AuthComponent;
};

export default withPrivateRouting;
